import { apiRequest } from './httpClient';

// Email bilateral: manda el correo con Reply-To único (lead.{profileId}@reply.bbtspr.com)
// y lo registra en el inbox unificado. Requiere sesión de admin.
export async function sendLeadEmail({ profileId, subject, message }) {
  return apiRequest('sendLeadEmail', {
    method: 'POST',
    body: { profileId, subject, message },
    requireAuth: true,
  });
}
